import { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";

interface LoaderProps {
  onDone: () => void;
}

export default function Loader({ onDone }: LoaderProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [pct, setPct] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const ctx = gsap.context(() => {
      const state = { v: 0 };
      const tl = gsap.timeline({
        onComplete: () => {
          gsap.to(el, {
            opacity: 0,
            duration: 0.4,
            ease: "power2.inOut",
            onComplete: () => {
              onDone();
            },
          });
        },
      });

      tl.to(state, {
        v: 100,
        duration: 1.2,
        ease: "power3.inOut",
        onUpdate: () => setPct(Math.round(state.v)),
      });

      tl.to(".loader-line", {
        scaleX: 1,
        duration: 1.2,
        ease: "power3.inOut",
      }, 0);

      tl.to(".loader-line", {
        scaleY: 30,
        duration: 0.35,
        ease: "power4.in",
      }, 1.2);
    }, ref);

    return () => ctx.revert();
  }, [onDone]);

  return (
    <div
      ref={ref}
      className="fixed inset-0 z-[100] ink-bg flex flex-col items-center justify-center"
      aria-hidden="true"
    >
      <div className="w-full max-w-[1400px] px-8 flex items-center justify-between type-label text-[color:var(--gray)]">
        <span>REMI / AI</span>
        <span className="tabular">CALIBRATION</span>
        <span>—</span>
        <span>2026</span>
      </div>

      <div className="mt-16 relative w-[60vw] max-w-[900px] h-[2px] overflow-visible">
        <div
          className="loader-line absolute inset-0 origin-left"
          style={{
            transformOrigin: "left center",
            transform: "scaleX(0)",
            background: "var(--paper)",
          }}
        />
      </div>

      <div className="mt-16 type-mono text-[color:var(--paper)] text-sm tabular">
        INITIALIZING {String(pct).padStart(3, "0")}%
      </div>
    </div>
  );
}